export const LIST_ITEM_CLASSIFICATION_REQUEST = 'LIST_ITEM_CLASSIFICATION_REQUEST'
export const LIST_ITEM_CLASSIFICATION_SUCCESS = 'LIST_ITEM_CLASSIFICATION_SUCCESS'
export const LIST_ITEM_CLASSIFICATION_FAIL = 'LIST_ITEM_CLASSIFICATION_FAIL'

export const LIST_ITEM_CLASSIFICATION_SUMMARY_REQUEST = 'LIST_ITEM_CLASSIFICATION_SUMMARY_REQUEST'
export const LIST_ITEM_CLASSIFICATION_SUMMARY_SUCCESS = 'LIST_ITEM_CLASSIFICATION_SUMMARY_SUCCESS'
export const LIST_ITEM_CLASSIFICATION_SUMMARY_FAIL = 'LIST_ITEM_CLASSIFICATION_SUMMARY_FAIL'

export const CREATE_ITEM_CLASSIFICATION_REQUEST = 'CREATE_ITEM_CLASSIFICATION_REQUEST'
export const CREATE_ITEM_CLASSIFICATION_SUCCESS = 'CREATE_ITEM_CLASSIFICATION_SUCCESS'
export const CREATE_ITEM_CLASSIFICATION_FAIL = 'CREATE_ITEM_CLASSIFICATION_FAIL'

export const DETAIL_ITEM_CLASSIFICATION_REQUEST = 'DETAIL_ITEM_CLASSIFICATION_REQUEST'
export const DETAIL_ITEM_CLASSIFICATION_SUCCESS = 'DETAIL_ITEM_CLASSIFICATION_SUCCESS'
export const DETAIL_ITEM_CLASSIFICATION_FAIL = 'DETAIL_ITEM_CLASSIFICATION_FAIL'

export const UPDATE_ITEM_CLASSIFICATION_REQUEST = 'UPDATE_ITEM_CLASSIFICATION_REQUEST'
export const UPDATE_ITEM_CLASSIFICATION_SUCCESS = 'UPDATE_ITEM_CLASSIFICATION_SUCCESS'
export const UPDATE_ITEM_CLASSIFICATION_FAIL = 'UPDATE_ITEM_CLASSIFICATION_FAIL'

export const DELETE_ITEM_CLASSIFICATION_REQUEST = 'DELETE_ITEM_CLASSIFICATION_REQUEST'
export const DELETE_ITEM_CLASSIFICATION_SUCCESS = 'DELETE_ITEM_CLASSIFICATION_SUCCESS'
export const DELETE_ITEM_CLASSIFICATION_FAIL = 'DELETE_ITEM_CLASSIFICATION_FAIL'
